<template src="../templates/normal_fcont_123.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfilePepal from '../components/CreatorProfilePepal'
import PrintButton from '../components/PrintButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreatorProfilePepal,
    PrintButton,InfoMachineTranslation,AppDownloadCreative,
    AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['123-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['123-3']}
      ]
    };
  }
  
};
</script>
<style >
</style>

